import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { http } from 'wagmi'
import { mainnet, sepolia } from 'wagmi/chains'

import { isEnvProduction } from '../../util/app.helpers'

const isEnvProd = isEnvProduction() || true // @TODO Enforcing prod for now
const chains = [mainnet, sepolia]
const transports = isEnvProd
  ? {
      [mainnet.id]: http('https://rpc.ankr.com/eth')
    }
  : {
      [sepolia.id]: http()
    }

const getWagmiConfig = getDefaultConfig({
  appName: `qbx${!isEnvProd ? '-testing' : ''}`,
  projectId: process.env.REACT_APP_WALLET_PROJECT_ID,
  chains,
  transports,
  batch: { multicall: true },
  ssr: false
})

const getChain = () => {
  return isEnvProd ? mainnet : sepolia
}

export { getWagmiConfig, getChain }
